export const toIdArray = (value) => {
  const normalizeId = (item) => {
    const rawValue = item && typeof item === "object" ? item.value ?? item.id : item;
    const numericValue = Number(rawValue);

    return Number.isNaN(numericValue) ? rawValue : numericValue;
  };

  if (Array.isArray(value)) {
    return value
      .filter((item) => item !== null && item !== undefined && item !== "")
      .map(normalizeId)
      .filter((item) => item !== null && item !== undefined && item !== "");
  }

  if (value === null || value === undefined || value === "") {
    return [];
  }

  return [normalizeId(value)];
};

export const getRuleTypeOptions = (ruleTypes = {}) => {
  return Object.entries(ruleTypes).map(([value, label]) => ({ value, label }));
};

export const normalizeHolidayRule = (rule = {}) => {
  return {
    ...rule,
    branch_ids: toIdArray(rule.branch_ids ?? rule.branch_id),
    department_ids: toIdArray(rule.department_ids ?? rule.department_id),
    employment_ids: toIdArray(rule.employment_ids ?? rule.employment_id),
  };
};

export const normalizeHolidayRules = (rules = []) => {
  return rules.map((rule) => normalizeHolidayRule(rule));
};

export const sanitizeHolidayRule = (rule = {}) => {
  const normalizedRule = normalizeHolidayRule(rule);
  const baseRule = {
    id: normalizedRule.id,
    key: normalizedRule.key,
    holiday_id: normalizedRule.holiday_id,
    row_state: normalizedRule.row_state,
    name: normalizedRule.name,
    type: normalizedRule.type,
  };

  if (normalizedRule.type === "religion") {
    return {
      ...baseRule,
      religion_id: normalizedRule.religion_id ?? null,
    };
  }

  if (normalizedRule.type === "geo_location") {
    return {
      ...baseRule,
      country_id: normalizedRule.country_id ?? null,
      state_id: normalizedRule.state_id ?? null,
      city_id: normalizedRule.city_id ?? null,
    };
  }

  if (normalizedRule.type === "organization_structure") {
    return {
      ...baseRule,
      location_id: normalizedRule.location_id ?? null,
      branch_ids: normalizedRule.branch_ids,
    };
  }

  if (normalizedRule.type === "department") {
    return {
      ...baseRule,
      department_ids: normalizedRule.department_ids,
    };
  }

  if (normalizedRule.type === "employee") {
    return {
      ...baseRule,
      employment_ids: normalizedRule.employment_ids,
    };
  }

  return baseRule;
};
